export default "__VITE_ASSET__1fc581ce__"